/**
 * Office contacts JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class OfficeContacts
 */
export default class OfficeContacts {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        // The search input
        this.searchInput = $( document.getElementById( 'js-contactsearch-input' ) );

        // The first caching of all the events before hiding anything.
        this.contacts =  $( '.js-contact' );

        // Contacts area.
        this.contactsArea =  $( '.js-contacts-area' );
    }

    /**
     * All events of the class.
     * @return {void}
     */
    events() {
        // Bind a handler to the search text input box and fire a filtering method when the value changes if the word has at least three letters
        if( ! this.searchInput.length ) {
            return;
        }


        // Set a timeout variable to fire search only after user stops typing.
        let timeout = null;

        $( this.searchInput ).on( 'input', ( e ) =>  {

            // Clear the timeout if there was any set so that the method fires
            // only when the final timeout time has passed.
            clearTimeout( timeout );
            timeout = setTimeout( () => {
                this.FilterContactsByName( e, this.searchInput.val() );
            }, 500 );

        });
    }

    /**
     * With this method we make the changes that occur in the contact cards
     * when the text input changes.
     *
     * @param {event object} e
     */
    FilterContactsByName( e, inputText ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        // Remove the 'selected' class from every item.
        this.contacts.removeClass( 'js-contact--selected-name' );

        // This trims whitespace from the input.
        const formattedInputText = $.trim( inputText ).toLowerCase();

        // If the text is longer than two characters filter the cards.
        if ( formattedInputText.length > 2 && this.contacts.length > 0 ) {

            // Loop through each of the item from the initial page load.
            this.contacts.each( ( index, contact ) => {

                // Get the name data-attribute. Trim whitespace and set to lower case.
                const contactName = $.trim( contact.dataset.name ).toLowerCase();

                // If the written text input is found in the name, add a class to the card.
                if ( typeof contactName !== 'undefined' ) {

                    if ( contactName.indexOf( formattedInputText ) > -1 ) {
                        contact.classList.add( 'js-contact--selected-name' );
                    }
                }

            });

        } else { // If the input field's text's length is less than two, show all cards.
            if ( this.contacts.length > 0 ) {
                this.contacts.each( ( index, contact ) => {
                    contact.classList.add( 'js-contact--selected-name' );
                });
            }
        }

        // Remove empty categories
        this.contactsArea.find( '.js-contacts-area__wrapper .grid' ).each( ( index, data ) => {
            if ( data.querySelectorAll( '.js-contact--selected-name' ).length < 1 ) {

                // Go up two parents and hide that element
                data.parentNode.parentNode.classList.add( 'u-hide' );
            }
            else {

                // Remove 'u-hide' class from every category that has a result
                data.parentNode.parentNode.classList.remove( 'u-hide' );
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}
